import { z } from 'zod';
import { phoneSchema } from '../phone/phone.js';
import { otpCodeSchema } from '../phone/verification.js';
import { phoneVerificationIdSchema } from './primitives.js';
/**
 * Fuel's own WhatsApp phone verification routes (fuel.md section 8.3,
 * customers.md section 10). The web apps call these; the API calls the
 * Customers integration with Fuel's system secret and the signed-in employee,
 * so the browser never names the Customers person or the employee itself.
 */
/** The Fuel record a code is asked for. */
export const phoneVerificationRecordSchema = z.enum(['DEBTOR', 'PDA_CUSTOMER']);
const languageSchema = z.enum(['ar', 'en']).default('ar');
/**
 * POST /phone-verifications (dashboard). Without `recordId` it is the code of
 * a new debtor (`CREATE`); with it, the code of that record's phone change
 * (`CHANGE_PHONE` of its Customers person, or `CREATE` while it is not linked
 * yet). `reverify` asks for «إعادة التحقق»: the same purpose and target as the
 * record's failed outbox row, for its stored phone.
 */
export const requestFuelPhoneVerificationSchema = z.object({
    phone: phoneSchema,
    record: phoneVerificationRecordSchema,
    recordId: z.string().trim().min(1).max(64).optional(),
    reverify: z.boolean().default(false),
    language: languageSchema,
});
/** POST /pda/phone-verifications: a new purchase customer's phone (always `CREATE`). */
export const requestPdaPhoneVerificationSchema = z.object({
    phone: phoneSchema,
    language: languageSchema,
});
/** POST …/phone-verifications/{id}/verify. */
export const verifyFuelPhoneVerificationSchema = z.object({ code: otpCodeSchema });
/**
 * POST /debtors/{id}/reverify-phone and /pda-customers/{id}/reverify-phone
 * («إعادة التحقق», customers.md section 10.4). With the switch on the body
 * carries the verified code; with it off the row is re-queued without one.
 */
export const reverifyPhoneSchema = z.object({
    phoneVerificationId: phoneVerificationIdSchema.optional(),
});
//# sourceMappingURL=phone-verification.contract.js.map